<template>

  <modalo
    :title="$t('Choose a template')"
    type="mini"
    @hideModal="$emit('close')">

    <div class="vflex">
      <div>
        <div class="form-group">
          <input
            v-autofocus
            v-model="search"
            type="text"
            class="form-control"
            :placeholder="$t('Search template')"
            @input="setKeywords">
        </div>
      </div>
      <div class="vflex-row-1">

        <div
          v-if="errorMessage"
          class="alert alert-warning">
          {{ errorMessage }}
        </div>

        <!-- list with infinite scroll -->
        <ul
          v-else-if="templates.length"
          ref="scroller"
          class="list-group template-picker-list"
          @scroll="onScroll">
          <li
            v-for="template in templates"
            :key="template.name + template.language"
            class="list-group-item list-group-item-action template-picker-item"
            @click="$emit('select', template)">
            <div class="d-flex justify-content-between align-items-center">
              <strong>{{ template.name }}</strong>
              <span class="badge badge-light">{{ template.category }} · {{ template.language }}</span>
            </div>
            <div class="text-muted small mt-1 text-truncate">
              {{ bodyText(template) }}
            </div>
          </li>

          <li
            v-if="loadingMore"
            class="list-group-item text-center text-muted template-picker-loader">
            <i class="fa-solid fa-circle-notch fa-spin"></i>
          </li>
        </ul>

        <div
          v-else-if="loading"
          class="text-center text-muted py-3">
          <i class="fa-solid fa-circle-notch fa-spin"></i>
        </div>

        <div
          v-else
          class="text-muted text-center py-3">
          {{ $t('No templates found') }}
        </div>

      </div>
    </div>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-light"
        @click="$emit('close')">{{ $t('Cancel') }}</button>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'WhatsappTemplatePicker',
  props: {
    connectionId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      loadingMore: false,
      errorMessage: null,
      search: '',
      templates: [],
      page: 1,
      pages: 1
    }
  },
  computed: {
    hasMore () {
      return this.page < this.pages
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    fetch
    requests a page and either replaces (reset) or appends (scroll) the list
    */
    fetch (page, append) {
      const filters = {
        page: page,
        limit: this.$default.limit
      }

      if (this.search) {
        filters.name = '~' + this.search
      }

      return this.$store
      .dispatch('getMessagingChannelTemplates', {
        id: this.connectionId,
        filters: filters
      })
      .then((result) => {
        const docs = (result && result.docs) || []
        this.templates = append ? this.templates.concat(docs) : docs
        this.page = result.page || page
        this.pages = result.pages || 1
      })
    },
    /*
    loadData
    loads (or reloads) the list from the first page
    */
    loadData () {
      this.loading = true
      this.errorMessage = null

      this.fetch(1, false)
      .catch((error) => {
        this.errorMessage = (error.response && error.response.data && error.response.data.message) || this.$t('Something went wrong')
      })
      .finally(() => {
        this.loading = false
      })
    },
    /*
    loadMore
    appends the next page (infinite scroll)
    */
    loadMore () {
      if (!this.hasMore || this.loading || this.loadingMore) {
        return
      }

      this.loadingMore = true

      this.fetch(this.page + 1, true)
      .catch((error) => {
        this.errorMessage = (error.response && error.response.data && error.response.data.message) || this.$t('Something went wrong')
      })
      .finally(() => {
        this.loadingMore = false
      })
    },
    /*
    onScroll
    infinite scroll: loads the next page once the user is close to the bottom
    */
    onScroll () {
      if (!this.hasMore || this.loadingMore) {
        return
      }
      const el = this.$refs.scroller
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 120) {
        this.loadMore()
      }
    },
    /*
    setKeywords
    debounced search: reloads from the first page as the user types
    */
    setKeywords () {
      clearTimeout(this._searchTimer)
      this._searchTimer = setTimeout(() => {
        this.loadData()
      }, 400)
    },
    /*
    bodyText
    */
    bodyText (template) {
      const body = (template.components || []).find((component) => { return component.type === 'BODY' })
      return body ? body.text : ''
    }
  }
}
</script>

<style scoped>
.template-picker-list {
  max-height: 320px;
  overflow-y: auto;
}

.template-picker-item {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/composer/WhatsappTemplatePicker.vue